require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-mid-size-pick-up.json") })
        }
      }, "path---es-fleet-mid-size-pick-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-mid-size-pick-up!./.cache/json/es-fleet-mid-size-pick-up.json
// module id = 1085
// module chunks = 231608221292675